<template>
  <div id="custom_table">
    <b-table-simple table-class="custom_table" ref="customtable" :hover="hover" responsive>
      <slot name="header"></slot>
      <slot name="body"></slot>
    </b-table-simple>
    <b-pagination-nav :link-gen="linkGen"
                      :number-of-pages="totalPage"
                      v-model="currentPage"
                      use-router
                      align="center"
                      pills
                      class="custom_pagination"
                      first-class="goto"
                      last-class="goto"
                      next-class="goto"
                      prev-class="goto"
                      page-class="page_btn"
                      size="sm">
      <template v-slot:first-text>
        <b-icon-chevron-double-left/>
      </template>
      <template v-slot:prev-text>
        <b-icon-chevron-left/>
      </template>
      <template v-slot:next-text>
        <b-icon-chevron-right/>
      </template>
      <template v-slot:last-text>
        <b-icon-chevron-double-right/>
      </template>
    </b-pagination-nav>
  </div>
</template>

<script>
import {
  BIconChevronDoubleLeft,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronDoubleRight
} from 'bootstrap-vue'

export default {
  components: {
    BIconChevronDoubleLeft,
    BIconChevronLeft,
    BIconChevronRight,
    BIconChevronDoubleRight
  },
  props: {
    totalPage: {
      type: Number,
      default: 1
    },
    curPage: {
      type: Number,
      default: 1
    },
    hover: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentPage: this.curPage,
      numberOfPages: parseInt(this.totalPage)
    }
  },
  methods: {
    linkGen (pageNum) {
      // console.log(pageNum, this.$route.path, this.$route.query, this.$route,this.$route.hash)
      return `?page=${pageNum}`+this.$route.hash
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .custom_table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
  text-align: center;

  thead tr th {
    background-color: #F5FAFF;
    border-color: #F5FAFF;
    padding: 10px 15px;
    white-space: nowrap;
  }

  thead tr:first-child {
    th:first-child {
      border-left: 1px solid #F5FAFF;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    th:last-child {
      border-right: 1px solid #F5FAFF;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  tbody {
    td {
      border-top: 0px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      max-width: 180px;
      vertical-align: middle;
      padding: 0.45rem 0.75rem;
      white-space: nowrap;
    }

    tr:last-child td {
      border-bottom: 1px solid #f0f0f0;
    }
  }
}

::v-deep .custom_pagination {
  .page_btn {
    .page-link {
      border: none;
      font-style: normal;
      font-weight: normal;
      vertical-align: middle;
      min-width: 25px;
      min-height: 25px;
      /*font-size: 12px;*/

      &:focus {
        box-shadow: none;
      }
    }

    &.active .page-link {
      border: none;
      background: #18A0FB;
      color: #FFFFFF;
    }
  }

  .goto {
    .page-link {
      font-size: 10px;
      padding-top: 6px;
      padding-left: 7px;
      color: #d0d0d0;

      min-width: 25px;
      min-height: 25px;
      max-width: 25px;
      max-height: 25px;
      border: 1px solid #d0d0d0;
      box-sizing: border-box;
    }

    &.disabled .page-link {
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      box-sizing: border-box;

    }

    &.disabled:hover .page-link {
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      box-sizing: border-box;
      color: #BBBBBB;
    }

    &:hover .page-link {
      background: #FFFFFF;
      border: 1px solid #18A0FB;
      box-sizing: border-box;
    }
  }
}
</style>
